import { useReducer, useEffect } from 'react';
const initialOperativeSystemState = {
    isIos: false,
    isAndroid: false,
    isHuawei: false,
    isMobileOS: false,
    currentOS: '',
};
const OperativeSystemReducer = (state, action) => {
    switch (action.type) {
        case 'ios':
            return Object.assign(Object.assign({}, state), { isIos: action.state, currentOS: 'ios' });
        case 'android':
            return Object.assign(Object.assign({}, state), { isAndroid: action.state, currentOS: 'android' });
        case 'huawei':
            return Object.assign(Object.assign({}, state), { isHuawei: action.state, currentOS: 'huawei' });
        case 'isMobileOS':
            return Object.assign(Object.assign({}, state), { isMobileOS: action.state });
        default:
            return state;
    }
};
export const useOperativeSystem = () => {
    const [state, dispatch] = useReducer(OperativeSystemReducer, initialOperativeSystemState);
    const windowUserAgent = window.navigator.userAgent.toLowerCase();
    const setOperativeSystem = () => {
        const isIos = windowUserAgent.indexOf('iphone') > 1 || windowUserAgent.indexOf('ipad') > 1;
        if (isIos)
            dispatch({ type: 'ios', state: isIos });
        const isAndroid = windowUserAgent.indexOf('android') > 1;
        if (isAndroid)
            dispatch({ type: 'android', state: isAndroid });
        const isHuawei = windowUserAgent.indexOf('huawei') > 1;
        if (isHuawei)
            dispatch({ type: 'huawei', state: isHuawei });
        dispatch({ type: 'isMobileOS', state: isIos || isAndroid || isHuawei });
    };
    useEffect(() => {
        setOperativeSystem();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return Object.assign({}, state);
};
